







































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";
import { TicketSourceType } from "@/data/enums/tickets";
import { TicketStatusMap } from "@/data/enums/tickets";

@Component({
  components: {
    "ticket-status-dropdown": () =>
      import("@/components/app/global/tickets/ticketStatusDropdown.vue"),
    "ticket-department-dropdown": () =>
      import("@/components/app/global/tickets/ticketDepartmentDropdown.vue"),
    "ticket-controls-dropdown": () =>
      import("@/components/app/global/tickets/ticketControlsDropdown.vue"),
    "ticket-header-lead-detail": () =>
      import("@/components/app/global/tickets/ticketHeaderLeadDetail.vue"),
    "ticket-header-client-detail": () =>
      import("@/components/app/global/tickets/ticketHeaderClientDetail.vue"),
    "ticket-header-assignee-details": () =>
      import("@/components/app/global/tickets/ticketHeaderAssigneeDetails.vue"),
    "ticket-header-product-details": () =>
      import("@/components/app/global/tickets/ticketHeaderProductDetails.vue"),
    "remote-access-summary-msg": () =>
      import("@/components/app/admin/upmind/remoteAccessSummaryMsg.vue")
  }
})
export default class TicketHeader extends Mixins(Context, ClientMixin) {
  // Inject

  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;

  // Computed

  public get statusMap() {
    return TicketStatusMap();
  }

  public get ticketData() {
    return this.$ticketData();
  }

  public get hasEmailSource() {
    return this.ticketData.ticket.source_type === TicketSourceType.EMAIL;
  }

  public get ticketOpenedDatePath() {
    const sourceIP = this.ticketData.ticket.source_ip;
    if (this.isClient) return "_.ticket_opened_date.default";
    if (this.hasEmailSource) return "_.ticket_opened_date.email";
    if (sourceIP) return "_.ticket_opened_date.ip";
    return "_.ticket_opened_date.default";
  }

  public get dynamicTicketsRoute() {
    const parts = this.$route.path.split("/");
    parts.splice(-1);
    return {
      path: parts.join("/"),
      query: this.$route.query
    };
  }
}
